import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule, NbIconModule, NbButtonModule } from '@nebular/theme';
import { UtilityService } from 'src/app/core/services/utility.service';
import { Xliff } from 'src/app/models/drb-models/xliff';
import { translationLanguages } from '../../../../shared/constants/translation-languages';
import { NgFor, KeyValuePipe } from '@angular/common';
import { StringTranslationComponent } from '../edit-xliff/string-translation/string-translation.component';

@Component({
    selector: 'app-view-xliff',
    templateUrl: './view-xliff.component.html',
    styleUrls: ['./view-xliff.component.css'],
    imports: [NbCardModule, NbIconModule, NbButtonModule, NgFor, StringTranslationComponent, KeyValuePipe]
})
export class ViewXliffComponent implements OnInit {
  public xliff: Xliff;
  public translationLanguages = translationLanguages;

  constructor(protected ref: NbDialogRef<ViewXliffComponent>, public utility: UtilityService) {}

  public ngOnInit() {}

  public close() {
    this.ref.close();
  }

  public descOrder = (a, b) => {
    if (a.key < b.key) {
      return b.key;
    }
  };
}
